import { parsePhoneNumber } from 'libphonenumber-js/max';
import { useState } from 'react';
import { Country } from '../../utils/countryData';
import Input, { InputProps } from './Input';

export type PhoneInputProps = Omit<InputProps, 'onChange'> & {
  onChange: (value: string) => void;
  defaultCountry?: Country;
};

const getPhoneNumber = (value: string, defaultCountry?: Country) => {
  try {
    return parsePhoneNumber(value, defaultCountry);
  } catch (e) {
    return undefined;
  }
};

const PhoneInput = ({ defaultCountry, onChange, onBlur, ...props }: PhoneInputProps) => {
  const [value, setValue] = useState(props.value ?? '');
  return (
    <Input
      {...props}
      value={value}
      onChange={e => {
        const newValue = e.currentTarget.value;
        setValue(newValue);
        const phoneNumber = getPhoneNumber(newValue, defaultCountry);
        onChange(phoneNumber?.isValid() ? phoneNumber.formatInternational() : '');
      }}
      onBlur={e => {
        onBlur?.(e);
        const phoneNumber = getPhoneNumber(e.target.value, defaultCountry);
        setValue(phoneNumber?.isValid() ? phoneNumber.formatInternational() : '');
      }}
    />
  );
};

export default PhoneInput;
